import React from 'react';
import { Table } from '@tanstack/react-table';
import Checkbox from 'src/components/ui/Checkbox/Checkbox';
import { useOutsideClick } from 'src/hooks/utils';
import { formatFilterKey } from 'src/utils/general';
import styles from './ColumnSelectModal.module.scss';

export interface ColumnSelectModalProps {
  table: Table<any>;
  onClose: () => void;
  buttonLabels?: Record<string, string>;
}

const ColumnSelectModal: React.FC<ColumnSelectModalProps> = ({ table, onClose, buttonLabels }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  useOutsideClick(ref, onClose);

  return (
    <div ref={ref} className={styles.root}>
      <div className={styles.content}>
        <div className="flex flex-col gap-4">
          {table.getAllLeafColumns().map(column => {
            const canHide = column.getCanHide();
            if (!canHide) return null;
            const label = buttonLabels?.[column.id] || column.columnDef.meta?.label || formatFilterKey(column.id);
            return (
              <button
                type="button"
                onClick={column.getToggleVisibilityHandler()}
                key={column.id}
                className="flex items-center gap-8">
                <Checkbox disabled checked={column.getIsVisible()} />
                <span className="typo-text-14 text-full whitespace-nowrap capitalize">{label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectModal;
